import { render, staticRenderFns } from "./help.component.vue?vue&type=template&id=11ccb343"
import script from "./help.component.vue?vue&type=script&lang=js"
export * from "./help.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports